export default __webpack_public_path__ + "static/media/00.04fc0c9a.jpg";